/**
 * Crow’s Nest time-to-first-success / time-to-paywall.
 * Empty samples stay "—" — never invent a duration.
 */

export function formatMedianDays(medianDays) {
  if (medianDays == null || Number.isNaN(Number(medianDays))) return '—'
  const value = Number(medianDays)
  if (!Number.isFinite(value)) return '—'
  const rounded = Number(value.toFixed(1))
  if (rounded === 1) return '1 day'
  return `${Number.isInteger(rounded) ? String(rounded) : String(rounded)} days`
}

export function formatSampleSize(sampleSize) {
  const n = Number(sampleSize) || 0
  return n === 1 ? '1 venue' : `${n} venues`
}

export function mapConversionDuration(metric = {}) {
  const raw = metric.medianDays
  const medianDays =
    raw == null || raw === '' || Number.isNaN(Number(raw)) ? null : Number(raw)
  const sampleSize = Number(metric.sampleSize) || 0
  return {
    medianDays: Number.isFinite(medianDays) ? medianDays : null,
    sampleSize,
    medianLabel: formatMedianDays(
      Number.isFinite(medianDays) ? medianDays : null,
    ),
    sampleLabel: formatSampleSize(sampleSize),
  }
}

export function mapTimeToConversion(response = {}) {
  const totals = response.totals || {}
  return {
    definition: response.definition || null,
    range: response.range || null,
    filters: response.filters || {},
    totals: {
      timeToFirstSuccess: mapConversionDuration(totals.timeToFirstSuccess),
      timeToPaywall: mapConversionDuration(totals.timeToPaywall),
    },
    byFeature: (Array.isArray(response.byFeature)
      ? response.byFeature
      : []
    ).map(row => ({
      key: row.featureId || 'unattributed',
      featureId: row.featureId ?? null,
      featureName: row.featureName || row.featureId || 'Unattributed',
      timeToFirstSuccess: mapConversionDuration(row.timeToFirstSuccess),
      timeToPaywall: mapConversionDuration(row.timeToPaywall),
    })),
  }
}
